<div @fade class="app-login" [ngStyle]="{'grid-template-rows': !headerFooter ? 'auto' : '100px auto' }"
  *ngIf="!show && !showError" role="main">
  <app-header *ngIf="headerFooter" class="header-mobile"></app-header>
  <header *ngIf="headerFooter" class="header" role="banner">
    <div class="container-logo">
      <div class="logo"><img
          src="{{ showIcon === 1 ? './assets/temporals/Logo_Akana_Azul.png' : './assets/logos/' + this.country + '/' + 'Logo_SCF_red.png' }}"
          [ngStyle]="{'cursor':  showIcon === 1 ? 'pointer' : 'auto', 'width': showIcon !== 1 ? '130px' : '95px', 'padding': showIcon !== 1 ? '0 ' : '0'}"
          (click)="goToHome(showIcon === 1)" alt=""></div>
      <div class="faqs" (click)="saveUrl()" *ngIf="showIcon !== '4' && !contratacion">
        <p>{{'FAQS.NAME' | translate}}</p> &nbsp;&nbsp;&nbsp;<img src="./assets/logos' + this.country + '/' + '/faq.svg" alt="">
      </div>
    </div>
  </header>
  <div class="body" *ngIf="!contratacion" role="main">
    <div class="tabs-number" *ngIf="refreshEntityCode">
      <div class="tabs-container">
        <div class="tab-1" [ngClass]="{'current-tab': nextTab === 0}" (click)="backTab()">1</div>
        <!-- <div class="tab-2" [ngClass]="{'current-tab': nextTab === 1}">2</div> -->
      </div>
    </div>
    <div class="change-container" *ngIf="nextTab === 0">
      <div class="container-tittle">
        <p class="select-tittle"> {{ 'LOGIN.SELECT_ENTITY' | translate }}&nbsp;&nbsp;&nbsp;<img
            src="./assets/temporals/modal-information.svg" (click)="openModal()" alt=""> </p>
      </div>
      <div class="container-entities">
        <div class="container-entity" *ngFor="let entity of mainEntities; let i = index"
          (click)="getBankLink(entity.CodeBank)">
          <img (mousedown)="disableDragging($event)" [src]="'./assets/login/' + entity.CodeBank + '.svg'" alt="">
        </div>
      </div>
      <div class="container-search-entities rapidScore">
        <p>{{ 'LOGIN.NOT_FOUND_ENTITY' | translate }}</p>
        <app-search-entities [entities]="entities" (entityEmitter)="getBankLink($event)">
        </app-search-entities>
      </div>
    </div>
    <div class="change-container" *ngIf="nextTab === 1">
      <div class="container-tittle">
        <p class="select-tittle"> {{ 'LOGIN.IDENTIFICATION' | translate }}&nbsp;&nbsp;&nbsp;<img
            src="./assets/temporals/modal-information.svg" (click)="openModal()" alt=""> </p>
      </div>
      <div class="content-container">
        <div class="left">
          <div class="container-tittle">
            <p class="sub-tittle">{{'LOGIN.ADD_KEYS' | translate }} <span *ngIf="ent">{{ ent.Name }}</span>
            </p>
          </div>
        </div>
        <div class="right">
          <form [formGroup]="loginForm" method="POST" autocomplete="off">
            <div class="container-entities" *ngIf="ent">
              <div class="information-container">
                <img class="img-entity" [src]="'./assets/logos/' + this.country + '/' + findImg(ent.CodeBank)  + '.png'" alt=""
                  *ngIf="findImg(ent.CodeBank)">
                <img style="height: 100px;" *ngIf="!findImg(ent.CodeBank)" src="./assets/logos/' + this.country + '/' + 'generic-bank.svg" alt="">
              </div>
              <div class="credential-container">
                <div class="credentials">
                  <mat-form-field *ngIf="ent.Params.length > 2 && ent.Params[0].ParamsValue.length > 0">
                    <mat-label *ngIf="hiddeLabel">{{ ent.Params[0].Description }}</mat-label>
                    <mat-select matNativeControl formControlName="select">
                      <mat-option (click)="hiddeLabel = false; resetUser((ent.CodeBank === '1465')? 'ING': access.Value)"
                        [value]="access.Value" *ngFor="let access of ent.Params[0].ParamsValue">
                        {{access.Label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!-- <div class="input-control">
                    <div *ngIf="ent.CodeBank !== '1465'">
                      <div class="in" *ngFor="let in of ent.Params; let i = index">
                        <div *ngIf="ent.Params[0].ParamsValue.length === 0">
                          <input formControlName="{{in.Description}}"
                            [ngClass]="{'inputTouched': loginForm.get(in.Description).touched && loginForm.get(in.Description).value === '' }"
                            placeholder="{{ in.Description }}" type="{{ printPassword(in.Description) }}" required>
                        </div>
                        <div *ngIf="ent.Params[0].ParamsValue.length > 0">
                          <input *ngIf="ent.Params[0].ParamsValue.length > 0 && i > 0"
                            formControlName="{{in.Description}}"
                            [ngClass]="{'inputTouched': loginForm.get(in.Description) && loginForm.get(in.Description).touched && loginForm.get(in.Description).value === '' }"
                            placeholder="{{ in.Description }}" type="{{ printPassword(in.Description) }}" required>
                        </div>
                      </div>
                    </div>
                    
                    <div *ngIf="ent.CodeBank === '1465'">
                      <div class="in ing">
                        <input formControlName="user"
                          [ngClass]="{'inputTouched': loginForm.get('user').touched && loginForm.get('user').value === '' }"
                          placeholder="{{ 'LOGIN.ING.DNI' | translate }}" type="text" required>
                        <div class="date">
                          <input appOnlyNumbers maxlength="2"
                            [ngClass]="{'inputTouched': loginForm.get('day').touched && loginForm.get('day').value === '' }"
                            formControlName="day" placeholder="{{ 'LOGIN.ING.DAY' | translate }}" type="text" required>
                          <input appOnlyNumbers maxlength="2" formControlName="month"
                            [ngClass]="{'inputTouched': loginForm.get('month').touched && loginForm.get('month').value === '' }"
                            placeholder="{{ 'LOGIN.ING.MONTH' | translate }}" type="text" required>
                          <input appOnlyNumbers maxlength="4" formControlName="year"
                            [ngClass]="{'inputTouched': loginForm.get('year').touched && loginForm.get('year').value === '' }"
                            placeholder="{{ 'LOGIN.ING.YEAR' | translate }}" type="text" required>
                        </div>
                        <input appOnlyNumbers maxlength="6" type="password"
                          [ngClass]="{'inputTouched': loginForm.get('key').touched && loginForm.get('key').value === '' }"
                          formControlName="key" placeholder="{{ 'LOGIN.ING.KEY' | translate }}" required>
                      </div>
                    </div>
                    
                    <div *ngIf="loginForm.touched && formatInvalid" class="errors">
                      <p>{{ 'LOGIN.ERRORS.WRONG_DNI' | translate }}</p>
                    </div>
                    <div class="errors" *ngIf="autenticationFalse">
                      <p>
                        {{ 'LOGIN.ERRORS.CREDENTIALS' | translate }}
                      </p>
                    </div>
                    <div class="errors" *ngIf="limitedExceded">
                      <p>
                        {{ 'LOGIN.ERRORS.LIMITEDEXCEDED' | translate }}
                      </p>
                    </div>
                    <div class="errors" *ngIf="loginForm.errors">
                      <p *ngIf="loginForm.errors.wrongDay">
                        {{ 'LOGIN.ERRORS.WRONG_DATE' | translate }}
                      </p>
                    </div>
                    <div class="errors"
                      *ngIf="loginForm.get('year') && loginForm.get('year').errors && loginForm.get('year').errors.max">
                      <p>
                        {{ 'LOGIN.ERRORS.MAX' | translate }}
                      </p>
                    </div>
                    <div class="errors"
                      *ngIf="loginForm.get('year') && loginForm.get('year').errors && loginForm.get('year').errors.min">
                      <p>
                        {{ 'LOGIN.ERRORS.INMORTAL' | translate }}
                      </p>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="btn-container" [ngStyle]="{'justify-content': backButtonShow ? 'space-between' : 'flex-end' }">
        <button id="backStep" *ngIf="backButtonShow" class="back" type="button" (click)="backTab()">Atrás</button>
        <button id="ready" type="button" class="ready"
          [ngClass]="{'btn-disabled': !loginForm.valid && loginForm.errors, 'enable': loginForm.valid && !loginForm.errors }"
          (click)="showLoading()">{{ 'LOGIN.BUTTONS.READY' | translate }}</button>
      </div>
    </div>
  </div>
  <div class="body rapidScore" *ngIf="contratacion">
 

    <div class="change-container" *ngIf="nextTab === 0" role="main">
      <div class="login-left">
        <div class="container-tittle">
          <p class="select-tittle rapidScore"> {{ 'LOGIN.SELECT_ENTITY' | translate }}&nbsp;&nbsp;&nbsp;
            <span class="info-icon" (click)="openModal()">
              i
            </span>
        </div>
        <div class="disclaimer-select">
          <span [innerHTML]="'LOGIN.PAYMENTINFO' | translate | safeHtml"></span>
        </div>
        <div class="main-entities">
          <div class="container-entity" *ngFor="let entity of mainEntities; let i = index"
            (click)="getBankLink(entity.CodeBank)">
            <div (mousedown)="disableDragging($event)" class="image-container"
              [style.background-image]="'url(./assets/login/' + entity.CodeBank + '.svg)'">

            </div>
          </div>
          <p class="psd2-disclaimer">
            <span [innerHTML]="'LOGIN.PSD2' | translate | safeHtml"></span>
          </p>

        </div>
      </div>
      <div class="login-right">
        <div class="container-search-entities rapidScore">
          <p>{{ 'LOGIN.NOT_FOUND_ENTITY' | translate }}</p>
          <app-search-entities [contratacion]="true" [entities]="entities" (entityEmitter)="getBankLink($event)">
          </app-search-entities>
        </div>
      </div>


    </div>
    <div class="change-container" *ngIf="nextTab === 1" role="main">
    
      <div class="content-container">
        <div class="left">
          <div class="container-tittle">
            <div class="back-container">
              <a href="javascript:void(0)" (click)="backTab()">< Volver</a>
             </div>
            <p class="select-tittle rapidScore"> {{ 'LOGIN.IDENTIFICATION' | translate }} </p>
          </div>
          <div class="container-tittle">
            <p class="sub-tittle rapidScore">{{'LOGIN.ADD_KEYS' | translate }} <span *ngIf="ent">{{ ent.Name }}</span>
            </p>
          </div>
          <img class="keys-img" src="./assets/login/keys.png" alt="keys">

        </div>
        <div class="right">
          <form [formGroup]="loginForm" method="POST" autocomplete="off">
            <div class="container-entities" *ngIf="ent">
              <div class="information-container rapidScore">
                <img class="img-entity" [src]="'./assets/logos/' + this.country + '/' + findImg(ent.CodeBank)  + '.png'" alt=""
                  *ngIf="findImg(ent.CodeBank)">
                <img style="height: 100px;" *ngIf="!findImg(ent.CodeBank)" src="./assets/logos/' + this.country + '/' + 'generic-bank.svg" alt="">
              </div>
              <div class="credential-container">
                <div class="credentials">
                  <mat-form-field *ngIf="ent.Params.length > 2 && ent.Params[0].ParamsValue.length > 0">
                    <mat-label *ngIf="hiddeLabel">{{ ent.Params[0].Description }}</mat-label>
                    <mat-select matNativeControl formControlName="select">
                      <mat-option (click)="hiddeLabel = false; resetUser((ent.CodeBank === '1465')? 'ING': access.Value)"
                        [value]="access.Value" *ngFor="let access of ent.Params[0].ParamsValue">
                        {{access.Label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="input-control">
                    <div *ngIf="ent.CodeBank !== '1465'">
                      <div class="in" *ngFor="let in of ent.Params; let i = index">
                        <div *ngIf="ent.Params[0].ParamsValue.length === 0">
                          <input class="rapidScore" formControlName="{{in.Description}}"
                            [ngClass]="{'inputTouched': loginForm.get(in.Description).touched && loginForm.get(in.Description).value === '' }"
                            placeholder="{{ in.Description }}" type="{{ printPassword(in.Description) }}" required aria-label="description1">
                        </div>
                        <div *ngIf="ent.Params[0].ParamsValue.length > 0">
                          <input class="rapidSocore" *ngIf="ent.Params[0].ParamsValue.length > 0 && i > 0"
                            formControlName="{{in.Description}}"
                            [ngClass]="{'inputTouched': loginForm.get(in.Description) && loginForm.get(in.Description).touched && loginForm.get(in.Description).value === '' }"
                            placeholder="{{ in.Description }}" type="{{ printPassword(in.Description) }}" required aria-label="description2">
                        </div>
                      </div>
                    </div>
                    <!-- ING BANK------------------->
                    <div *ngIf="ent.CodeBank === '1465'">
                      <div class="in ing">
                        <input formControlName="user"  class="rapidScore"
                          [ngClass]="{'inputTouched': loginForm.get('user').touched && loginForm.get('user').value === '' }"
                          placeholder="{{ 'LOGIN.ING.DNI' | translate }}" type="text" required aria-label="DNI">
                        <div class="date">
                          <input appOnlyNumbers maxlength="2"  class="rapidScore"
                            [ngClass]="{'inputTouched': loginForm.get('day').touched && loginForm.get('day').value === '' }"
                            formControlName="day" placeholder="{{ 'LOGIN.ING.DAY' | translate }}" type="text" required aria-label="day">
                          <input appOnlyNumbers maxlength="2" formControlName="month"  class="rapidScore"
                            [ngClass]="{'inputTouched': loginForm.get('month').touched && loginForm.get('month').value === '' }"
                            placeholder="{{ 'LOGIN.ING.MONTH' | translate }}" type="text" required aria-label="month">
                          <input appOnlyNumbers maxlength="4" formControlName="year"  class="rapidScore"
                            [ngClass]="{'inputTouched': loginForm.get('year').touched && loginForm.get('year').value === '' }"
                            placeholder="{{ 'LOGIN.ING.YEAR' | translate }}" type="text" required aria-label="year">
                        </div>
                        <input appOnlyNumbers maxlength="6" type="password"  class="rapidScore"
                          [ngClass]="{'inputTouched': loginForm.get('key').touched && loginForm.get('key').value === '' }"
                          formControlName="key" placeholder="{{ 'LOGIN.ING.KEY' | translate }}" required aria-label="key">
                      </div>
                    </div>
                    <!-- END ING BANK--------------->
                    <div *ngIf="loginForm.touched && formatInvalid" class="errors">
                      <p>{{ 'LOGIN.ERRORS.WRONG_DNI' | translate }}</p>
                    </div>
                    <div class="errors" *ngIf="autenticationFalse">
                      <p>
                        {{ 'LOGIN.ERRORS.CREDENTIALS' | translate }}
                      </p>
                    </div>
                    <div class="errors" *ngIf="limitedExceded">
                      <p>
                        {{ 'LOGIN.ERRORS.LIMITEDEXCEDED' | translate }}
                      </p>
                    </div>
                    <div class="errors" *ngIf="loginForm.errors">
                      <p *ngIf="loginForm.errors.wrongDay">
                        {{ 'LOGIN.ERRORS.WRONG_DATE' | translate }}
                      </p>
                    </div>
                    <div class="errors"
                      *ngIf="loginForm.get('year') && loginForm.get('year').errors && loginForm.get('year').errors.max">
                      <p>
                        {{ 'LOGIN.ERRORS.MAX' | translate }}
                      </p>
                    </div>
                    <div class="errors"
                      *ngIf="loginForm.get('year') && loginForm.get('year').errors && loginForm.get('year').errors.min">
                      <p>
                        {{ 'LOGIN.ERRORS.INMORTAL' | translate }}
                      </p>
                    </div>
                    <div class="btn-container rapidScore" style="margin-top: 30px;" [ngStyle]="{'justify-content': backButtonShow ? 'center' : 'flex-end' }">
                      <button style="min-width: 0" id="ready" type="button" class="ready rapidScore"
                        [ngClass]="{'btn-disabled': !loginForm.valid && loginForm.errors, 'enable': loginForm.valid && !loginForm.errors }" aria-label="Continuar"
                        (click)="showLoading()">{{ 'Continuar' | translate }}</button>
                    </div>
                  </div>
                  
                </div>
                <!-- <div class="button-continue">
                  <button id="ready" type="button" class="ready"
                  [ngClass]="{'btn-disabled': !loginForm.valid && loginForm.errors, 'enable': loginForm.valid && !loginForm.errors }"
                  (click)="showLoading()">{{ 'Continuar' | translate }}</button>
                </div> -->
              </div>
             
            </div>
          </form>
        </div>
      </div>
     
    </div>
  </div>
  <app-footer *ngIf=" !contratacion && headerFooter" class="footer" [colorItems]="'#ffffff'" [classSpecial]="true" role="contentinfo">
  </app-footer>
</div>
<app-loading *ngIf="show" [headerFooter]="headerFooter"></app-loading>
<app-error-server [headerFooter]="headerFooter" (closeError)="showError = false" *ngIf="showError"></app-error-server>